import { motion } from "framer-motion";
import { FaTelegram } from "react-icons/fa";
import SocialShare from "./SocialShare";
import CountdownTimer from "./CountdownTimer";

const TELEGRAM_LINK = "https://t.me/thegoldcastai";

export default function FooterSection({ onCtaClick }) {
  return (
    <footer
      data-testid="footer-section"
      className="pt-20 pb-16 flex flex-col items-center gap-12 px-4"
    >
      {/* Final CTA */}
      <motion.div
        className="text-center max-w-xl"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2
          className="text-2xl sm:text-3xl font-bold text-white mb-4"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Ready to <span className="text-[#FF007F]">Transform</span> Your Trading?
        </h2>
        <p className="text-[#A1A1AA] text-base leading-relaxed">
          Join our exclusive Telegram channel. Something massive is coming.
          Be the first to know.
        </p>
      </motion.div>

      {/* Countdown */}
      <motion.div
        className="flex flex-col items-center gap-3"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        <p className="text-[#71717A] text-xs tracking-widest uppercase">Something big is coming</p>
        <CountdownTimer />
      </motion.div>

      {/* Join Waiting Room Button */}
      <motion.a
        href={TELEGRAM_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-cta-btn"
        onClick={onCtaClick}
        className="flex items-center gap-3 bg-[#FF007F] text-white font-bold py-4 px-10 rounded-full text-lg hover:bg-[#E60073] transition-all duration-300 hover:scale-105"
        style={{ boxShadow: "0 0 30px rgba(255,0,127,0.4)" }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <FaTelegram size={24} />
        Join the Waiting Room
      </motion.a>

      {/* Social share */}
      <SocialShare />

      {/* Hashtags */}
      <motion.div
        data-testid="hashtags-section"
        className="flex flex-col items-center gap-3"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <span className="text-[#FF007F] font-mono tracking-[0.25em] text-lg sm:text-2xl font-semibold">
          #somethingbigiscoming
        </span>
        <span className="text-[#FF007F] font-mono tracking-[0.25em] text-lg sm:text-2xl font-semibold">
          #22april2026
        </span>
      </motion.div>

      {/* Brand footer */}
      <div className="text-center mt-8">
        <p className="text-[#71717A] text-xs tracking-wide">
          &copy; {new Date().getFullYear()} Fira Worldwide. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
